const MULTIPLIER = 31;

const colorVariants = {
  blue: ['blue600', 'blue700', 'blue800'],
  brandBlue: ['brandBlue600', 'brandBlue700', 'brandBlue800'],
  green: ['green600', 'green700', 'green800'],
  pink: ['pink600', 'pink700', 'pink800'],
  purple: ['purple600', 'purple700', 'purple800'],
  red: ['red600', 'red700', 'red800'],
  yellow: ['yellow700', 'yellow800', 'yellow900'],
};

/**
 * Given an ID this function will return a semi-random color from AVATAR_COLORS
 * that will persist across page loads if given the same ID value
 *
 * Logic for generating a random number from the ID value adapted from:
 * https://gist.github.com/hyamamoto/fd435505d29ebfa3d9716fd2be8d42f0
 */

type UseContactAvatarColorProps = {
  seed: string;
  themeColors: Record<string, string>;
};

export const generateContactAvatarColors = ({
  seed,
  themeColors,
}: UseContactAvatarColorProps): string[] => {
  const colorVariantKeys = Object.keys(colorVariants);
  const hashCode = Array.from(seed).reduce(
    // eslint-disable-next-line no-bitwise
    (sum, char) => (Math.imul(MULTIPLIER, sum) + char.charCodeAt(0)) | 0,
    0,
  );

  const index = Math.abs(hashCode) % colorVariantKeys.length;
  const colorVariantsKeyFromIndex = colorVariantKeys[index] as keyof typeof colorVariants;

  return colorVariants[colorVariantsKeyFromIndex].map(
    (themeColorToken) => themeColors[themeColorToken],
  );
};
